/* @flow */

export {AccentBorder} from './accent-border';
